module.exports = __webpack_public_path__ + "fonts/raraya_font.447fc467.woff2";